










import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import store from '@/store/store'
import Chat from './ChatMessage.vue'
import ChatMessage from '../../models/ChatMessage'

@Component({
	components: {
		Chat
	},
	watch: {
		messages(curV, prev){
			let tg = this as ChatChannel;
			let cur = (this as any).messages as ChatMessage[];
			if (cur && cur.length != tg.msgCount)
			{
				tg.msgCount = cur.length;
				if (cur.length > 0)
				{
					this.$emit('message', cur[cur.length - 1]);
				}
				(this as any).scrollToBottom();
			}
		}
	}
})
export default class ChatChannel extends Vue {
	@Prop(Number) readonly channel!: number;
	get messages(){
		let b = (store.state as any).project.chatTracker;
		let res = (store.state as any).project.chatChannels.get(this.channel);
		if (!res)
		{
			return b ? [] : [];
		}
		if (this.msgCount == -1)
		{
			this.msgCount = res.length;
		}
		return b ? res : res;
	}

	msgCount = -1

	/*mounted(){
		this.$nextTick(()=>{
			this.scrollToBottom();
		})
	}*/

	scrollToBottom(){
		this.$nextTick(()=>{
			this.$emit('request-scroll');
			let div = this.$refs.channelRoot as HTMLDivElement;
			if (div)
			{
				div.scrollTop = div.scrollHeight;
			}
		})
	}
}
